import { UserBlockingError } from '@hookmyapp/observability/errors';

// D2a: success-body parsing is deliberately tolerant for legitimate empty
// successes, but strict for malformed JSON that claimed to be JSON.
export async function parseBody<T>(res: Response): Promise<T> {
  if (res.status === 204) return undefined as T;

  const contentType = res.headers.get('content-type') ?? '';
  if (!contentType.includes('application/json')) return undefined as T;

  const text = await res.text();
  if (text.trim() === '') return undefined as T;

  try {
    return JSON.parse(text) as T;
  } catch {
    throw new UserBlockingError({
      message: `Failed to parse JSON success body (status ${res.status})`,
      code: 'QUERY_JSON_PARSE_FAIL',
      details: { status: res.status },
    });
  }
}
